// This file is AUTOGENERATED, do not edit it manually!!!

export const menu = {
    activityList: 'Projekte',
    addlicenses: 'Lizenzen hinzufügen',
    approvals: 'Genehmigungsanfragen',
    billingReport: 'Abrechnungsbericht',
    companySettings: 'Firmeneinstellungen',
    customers: 'Kunden',
    customfields: 'Benutzerdefinierte Felder',
    dashboard: 'Dashboard',
    forms: 'Benutzerdefinierte formulare',
    generalOptions: 'Kontoeinstellungen',
    guestPortal: 'Gäste-Portal',
    logout: 'Abmelden',
    myassignments: 'Meine aufgaben',
    myoptions: 'Meine Einstellungen',
    mySettingsNotifications: 'Benachrichtigungen',
    mySettingsOptions: 'Einstellungen',
    mySettingsProfile: 'Profil',
    myvacations: 'Meine Urlaubstage',
    notifications: 'Benachrichtigungseinstellungen',
    payrollReport: 'Bericht zu Gehaltsabrechnungen',
    portfolios: 'Portfolios',
    powerbi: 'BI dashboards',
    presetsListTitle: 'Gespeicherte ansichten',
    reportgenerator: 'Benutzerdefinierter Bericht',
    reports: 'Berichte',
    resourcesPage: 'Ressourcen',
    roles: 'Rollen',
    search: 'Suchen',
    summaryReport: 'Zusammenfassender Bericht',
    support_center: 'Supportcenter',
    support_chat: 'Support-Chat',
    systemLists: 'Systemlisten',
    timelogs: 'Zeitprotokolle',
    updateLicense: 'Lizenz aktualisieren',
    vacationsreport: 'Urlaubstage',
    whatif: 'Simulation der Ressourcenauslastung',
};
